import { Table } from '@tanstack/react-table';
import { UseFormReturn } from 'react-hook-form';

import {
  GenerateEntityFooter,
  GenerateEntityFooterProps,
} from '@/modules/finance/common/components';

import { useInvoicesGenerateDisabled } from '../hooks/use-invoices-generate-disabled';
import { GenerateInvoiceListItem } from '../types';
import { GenerateInvoicesTableFormValues } from '../validations/generate-invoices-validation';

interface GenerateInvoicesFooterProps
  extends Omit<GenerateEntityFooterProps, 'isGenerateDisabled' | 'disabledReason'> {
  form: UseFormReturn<GenerateInvoicesTableFormValues>;
  table: Table<GenerateInvoiceListItem>;
}

/**
 * Footer of the Generate Invoices screen. Owns the "can we generate?" validation, which has to watch the
 * whole form: keeping that subscription here means an edit or a newly mounted line re-renders
 * this footer only — not the page and its table.
 */
export const GenerateInvoicesFooter = ({
  form,
  table,
  selectedItemsCount,
  ...footerProps
}: GenerateInvoicesFooterProps) => {
  const { isGenerateDisabled, disabledReason } = useInvoicesGenerateDisabled({
    form,
    table,
    selectedRowsCount: selectedItemsCount,
  });

  return (
    <GenerateEntityFooter
      {...footerProps}
      selectedItemsCount={selectedItemsCount}
      isGenerateDisabled={isGenerateDisabled}
      disabledReason={disabledReason}
    />
  );
};
